import { Spinner as BPSpinner } from "@blueprintjs/core"
import styled from "@emotion/styled"

const Spinner = styled(BPSpinner)<{
  color?: string
  headcolor?: string
}>`
  &.bp6-spinner .bp6-spinner-track {
    stroke: ${(props) => props.color};
  }
  &.bp6-spinner .bp6-spinner-head {
    stroke: ${(props) => props.headcolor};
  }
`

type ColorSpinnerProps = {
  className?: string
  color?: string
  headcolor?: string
  size?: number
  intent?: "primary" | "success" | "warning" | "danger"
  value?: number
}

const ColorSpinner = ({
  color,
  headcolor,
  size,
  ...props
}: ColorSpinnerProps) => (
  <Spinner {...props} color={color} headcolor={headcolor} size={size} />
)

export default ColorSpinner
